module.exports = __webpack_public_path__ + "static/media/vipImage.bcb7ad45.svg";